  import { Component, inject, Inject, OnInit } from '@angular/core';
  import { FormsModule } from '@angular/forms';
  import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
  import { Api } from '../../services/api';
  import { RegionService } from '../../services/region.service';
  import { CommonModule } from '@angular/common';
  import { NgSelectModule } from '@ng-select/ng-select';
  import { error } from 'console';
import { AlertService } from '../../services/alert.service';

  @Component({
      standalone:true,
      selector: 'app-mdl-manage-goals',
      imports: [FormsModule,CommonModule, NgSelectModule],
      templateUrl: './mdl-manage-goals.html',
      styleUrls: ['./mdl-manage-goals.css']

  })
  export class MdlManageGoals implements OnInit {
      private api = inject(Api);
  private alertService = inject(AlertService);

      constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public mdl: MatDialogRef<MdlManageGoals >
    ) {}


    public meta: any = {};
    public selectedUsers: string[] = [];

      public request: any = {
          descripcion: '',
          valor_objetivo: 0,
          fecha_inicio: '',
          fecha_fin: '',
          usuario_id: [] as string[],
          estado: 'Sin iniciar',
          progreso_actual: 0,
      }
      public users: any = [];
      



      ngOnInit(): void {
          this.getUsers();
          console.log('Data recibida del modal anterior:', this.data);

          if (this.data.mode === 'edit' ){
              this.meta = this.data.meta;
              this.request.meta_id = this.meta.meta_id;
              this.request.descripcion = this.meta.descripcion;
              this.request.valor_objetivo = this.meta.valor_objetivo;
              this.request.fecha_inicio = this.meta.fecha_inicio;
              this.request.fecha_fin = this.meta.fecha_fin;
              this.request.usuario_id = this.meta.usuario_id;
              this.request.estado = this.meta.estado;
              
              this.selectedUsers = Array.isArray(this.meta.usuario_id) ? this.meta.usuario_id : [this.meta.usuario_id];


      }}

      closeMdl() {
      this.mdl.close();
    }

    createMeta() {
      this.api.showLoading();

      this.request.usuario_id = this.selectedUsers; 

      this.api.createGoal(this.request).subscribe({
        next: () => {
          this.api.hideLoading()
          this.mdl.close(true);
        },
       error: (err) => {
      this.api.hideLoading();

      if (err.status === 409) {
        alert(` ${err.error.message}`);
      } else if(err?.status===403) {
          this.alertService.error('Acceso denegado',"No tienes permiso para crear prospectos.");
          this.mdl.close(false);
          return
      }
      this.alertService.error('Error','Ocurrió un problema al crear el prospecto.')
        this.mdl.close(false);
    }
  });
}

    updateMeta() {
      this.api.showLoading();
      try{
        this.api.updateGoal(this.request).subscribe({
          next:(data:any) =>{
            setTimeout(() => {
              this.api.hideLoading();
              window.location.reload();
            }, 500);
      },
      error: (error:any)=>{
        this.api.hideLoading();
        if (error?.status===403){
          this.alertService.error('Acceso denegado',"No tienes permiso para modificar prospectos.");
          this.mdl.close(false);
          return
        }
        this.alertService.error('Error','Ocurrió un problema al modificar el prospecto.')
        this.mdl.close(false);
            }
    });
      } catch (err) {
        console.error(err);
      }}


    getUsers(){
      try {
        this.api.getUsers().subscribe({
          next:(data:any) =>{
          console.log('Usuarios recibidos:', data.users);
            this.users = data.users|| [];

            this.users = (data.users || []).map((user: any) => ({
              ...user,
              nombreCompleto: `${user.nombre} ${user.apellido}`,
            }),);
          },
          error: (error:any)=>{
            console.error(error);
          }
        });
      } catch (error) {
        console.error(error);
      }
    }

  getUserName(id: string): string {
    const user = this.users.find((u :any) => u.usuario_id === id);
    return user ? user.nombreCompleto : '';
  }

  removeUser(id: string) {
    this.selectedUsers = this.selectedUsers.filter(u => u !== id);
  }

  closemdl() {
    this.mdl.close();
  }
  }